import dayjs from 'dayjs';

export const extractNumbers = (input: unknown): string | null => {
    if (typeof input !== 'string') {
        return null;
    }
    return input.replace(/\D/g, '');
};

export const formatDateTime = (dateString: string): string => {
    return dayjs(dateString).format('DD/MM/YYYY, HH:mm');
};
